import { baseUrl } from "../../baseUrl";
import { fetchWithAuthHandling } from "../../authHandling";

export const checkCallAvailability = async () => {
  try {
    const response = await fetchWithAuthHandling(
      `${baseUrl}/calls/availability`,
      {
        method: "GET",
        credentials: "include"
      }
    );

    if (!response.ok) throw new Error("Failed to check availability");

    const data = await response.json();

    if (data.available) {
      return true;
    }
    console.log("Not available");
    return false;
  } catch (error) {
    console.error("Error checking availability:", error);
    return false;
  }
};
